/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js"
import { useI18n } from 'vue-i18n'
import i18n from '@/plugins/i18n'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
    rtl: { ar: true },
  },
  theme: {
    defaultTheme: 'light',
  },
  icons: {
    defaultSet: "mdi",
    aliases: {
      ...aliases,
      // prev: mdiChevronRight,
      // next: mdiChevronLeft,
    },
    sets: {
      mdi,
    },
  },

})
